import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BranchMaintenanceRoutingModule } from './branch-maintenance-routing.module';
import { BranchMaintenanceComponent } from './branch-maintenance.component';
import { BranchMaintenanceFormComponent } from './branch-maintenance-form/branch-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { BranchMaintenanceFilterComponent } from './branch-maintenance-filter/branch-maintenance-filter.component';
import { ChainDropdownModule } from 'src/app/core/custom-modules/dropdowns/chain-dropdown/chain-dropdown.module';
import { CountryDropdownModule } from 'src/app/core/custom-modules/dropdowns/country-dropdown/country-dropdown.module';
import { RegionDropdownModule } from 'src/app/core/custom-modules/dropdowns/region-dropdown/region-dropdown.module';
import { ProvinceDropdownModule } from 'src/app/core/custom-modules/dropdowns/province-dropdown/province-dropdown.module';
import { CityDropdownModule } from 'src/app/core/custom-modules/dropdowns/city-dropdown/city-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    BranchMaintenanceRoutingModule,
    ChainDropdownModule,
    CountryDropdownModule,
    RegionDropdownModule,
    ProvinceDropdownModule,
    CityDropdownModule
  ],
  declarations: [BranchMaintenanceComponent, BranchMaintenanceFormComponent, BranchMaintenanceFilterComponent],
  entryComponents: [BranchMaintenanceFilterComponent]
})
export class BranchMaintenanceModule { }
